export const getEnumKeyByValue = <T>(enumObj: T, value: string): keyof T | undefined => {
  return Object.keys(enumObj).find((key) => enumObj[key as keyof T] === value) as keyof T | undefined;
};

export const getEnumValueByKey = <T>(enumObj: T, key: keyof T): string | undefined => {
  return enumObj[key] as string | undefined;
};
